import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  CircularProgress,
  Box,
  Autocomplete,
  Typography,
} from '@mui/material';

const StatusDialog = ({
  open,
  selectedLead,
  newStatus,
  conditionalData,
  statusOptions,
  frontSellerOptions,
  processingId,
  onClose,
  onStatusChange,
  onNewStatusChange,
  onConditionalChange,
}) => {
  const getSelectedAssignee = () => {
    return frontSellerOptions.find(seller => seller.id === conditionalData?.assignee_id) || null;
  };

  const handleAssignToChange = (event, value) => {
    onConditionalChange('assignee_id', value ? value.id : '');
  };

  const selectedStatus = statusOptions.find((s) => s.id === newStatus);
  const statusName = selectedStatus?.name;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Change Lead Status</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>New Status</InputLabel>
          <Select 
            value={newStatus} 
            onChange={(e) => onNewStatusChange(e.target.value)} 
            label="New Status"
          >
            {statusOptions.map((s) => (
              <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* SELECT Status Fields */}
        {statusName !== 'Meeting' && statusName && (
          <Box sx={{ mt: 3, gap: 2, display: 'flex', flexDirection: 'column' }}>
            <TextField
              label="Date"
              type="date"
              value={conditionalData.date}
              onChange={(e) => onConditionalChange('date', e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <TextField
              label="Description"
              multiline
              rows={3}
              value={conditionalData.description}
              onChange={(e) => onConditionalChange('description', e.target.value)}
              placeholder="Reason / notes…"
              fullWidth
            />
          </Box>
        )}

        {/* MEETING Status Fields */}
        {statusName === 'Meeting' && (
          <Box sx={{ mt: 3, gap: 2, display: 'flex', flexDirection: 'column' }}>
            <FormControl fullWidth>
              <Autocomplete
                options={frontSellerOptions}
                getOptionLabel={(option) => option.name}
                value={getSelectedAssignee()}
                onChange={handleAssignToChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search and select assignee"
                    label="Select assignee"
                  />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                noOptionsText="No assignee found"
              />
            </FormControl>
            
            <FormControl fullWidth>
              <InputLabel>Time Zone</InputLabel>
              <Select
                value={conditionalData.timeZone}
                onChange={(e) => onConditionalChange('timeZone', e.target.value)}
                label="Time Zone"
              >
                <MenuItem value="UTC">UTC</MenuItem>
                <MenuItem value="EST">EST</MenuItem>
                <MenuItem value="PST">PST</MenuItem>
                <MenuItem value="CST">CST</MenuItem>
                <MenuItem value="GMT">GMT</MenuItem>
              </Select>
            </FormControl>
            
            <TextField
              label="Start Date & Time"
              type="datetime-local"
              value={conditionalData.startDateTime}
              onChange={(e) => onConditionalChange('startDateTime', e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            
            <TextField
              label="End Date & Time"
              type="datetime-local"
              value={conditionalData.endDateTime}
              onChange={(e) => onConditionalChange('endDateTime', e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            
            <TextField
              label="Meeting Description"
              multiline
              rows={3}
              value={conditionalData.meetingDescription}
              onChange={(e) => onConditionalChange('meetingDescription', e.target.value)}
              placeholder="Agenda, purpose…"
              fullWidth
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onStatusChange}
          variant="contained"
          disabled={!newStatus || processingId === selectedLead?.id}
          startIcon={processingId === selectedLead?.id ? <CircularProgress size={20} /> : null}
        >
          Update Status
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StatusDialog;